import { StyleSheet } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import CourseCard from "../CourseCard/CourseCard";

function SchoolCardList({ courses = [], onPress }) {
  return (
    <ScrollView
      role="list"
      accessibilityRole="list"
      aria-label="School card list"
      horizontal={true}
      height={200}
      showsHorizontalScrollIndicator={false}
      style={styles.scrollView}
      tabIndex={0}>
      {courses.map((course, index) => (
        <CourseCard
          key={index}
          title={course?.team_name}
          category={null}
          duration={null}
          description={null}
          fillPercentage={null}
          logoUri={course?.logoUri}
          label={course?.provider_name}
          onPress={() => onPress(course?.id)}
        />
      ))}
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});

export default SchoolCardList;
